import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Button, DataDisplayPlain, Separator, Title } from '@e2n/ui/v2';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Guttage() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  if (!ctx.state.showGuttageStep) return null;
  return (
    <>
      <Separator />
      <div className="py-4 flex flex-col gap-2">
        <div className="flex items-center">
          <Title>
            {t('domain.mitarbeiter.create.steps.abwesenheiten.guttage.title')}
          </Title>
          <Button
            iconOnly
            className="ml-auto"
            variant={'secondary-red'}
            onClick={() => ctx.navigateToSubStep('abwesenheiten.guttage')}>
            <FontAwesomeIcon icon={faPen} />
          </Button>
        </div>
        <DataDisplayPlain
          orientation="horizontal"
          variant="text"
          label={t(
            'domain.mitarbeiter.create.steps.abwesenheiten.guttage.form.guttageBewerten.label',
          )}
          item={t(
            'domain.mitarbeiter.create.steps.abwesenheiten.guttage.form.guttageBewerten.options.' +
              data.abwesenheiten.guttage.guttageBewerten,
          )}
        />
      </div>
    </>
  );
}
